import { useMemo } from 'react';
import {
  InvoiceRequireApId,
  InvoiceRequireExternalSupplierName,
} from 'src/constants/permissionsList';
import usePermission from 'src/hooks/usePermissions';
import { SupplierRequiredFields } from 'src/types/manage-suppliers/SupplierForm';

/** AP ID / External Supplier Name are each required only when the user has the matching permission. */
const useSupplierRequiredFields = (): SupplierRequiredFields => {
  const apId = usePermission({ permissions: InvoiceRequireApId });
  const externalSupplierName = usePermission({ permissions: InvoiceRequireExternalSupplierName });

  return useMemo(() => ({ apId, externalSupplierName }), [apId, externalSupplierName]);
};

export default useSupplierRequiredFields;
